import { REPORT_RECEIVED, REPORT_UNLOADED } from './types.js'

export default function report(state = {}, action = {}){
  switch (action.type) {
    case REPORT_RECEIVED:
      return action.data
    case REPORT_UNLOADED:
      return {}
    default:
      return state
  }
}
